/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */

import React, { FC, FormEvent, useCallback } from 'react';

import { Button, Container, Paper, Typography, WithStyles, withStyles } from '@material-ui/core';
import OAuthLoginStyles from '~/config/auth/OAuthLoginStyles';

type IProps = WithStyles<typeof OAuthLoginStyles> & {
  onSubmit: () => void;
};

const SignInUnstyled: FC<IProps> = ({ classes, onSubmit }) => {
  const onSubmitCapture = useCallback(
    (event: FormEvent) => {
      event.preventDefault();
      onSubmit();
    },
    [onSubmit]
  );

  return (
    <div className={classes.wrap}>
      <Container component="main" maxWidth="xs">
        <Paper className={classes.paper}>
          <Typography align="center" component="h3" className={classes.header}>
            Авторизация
          </Typography>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.marginTop}
            onClick={onSubmitCapture}
          >
            Вход через Jira
          </Button>
        </Paper>
      </Container>
    </div>
  );
};

const OAuthLogin = withStyles(OAuthLoginStyles, { withTheme: true })(SignInUnstyled);

export { OAuthLogin };
